var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container animated",class:{'fadeIn':_vm.finished},style:('backgroundImage: url(' + _vm.imageUrl + ')')},[(!_vm.finished)?_c('i',{staticClass:"iconfont icon-jiazai"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }